import { connect } from 'react-redux';
import { getPaginationUrl } from 'shared/components/Paginator';
import { createDigitalOrder, getDownloadUrl, searchDigitalOrders, updateDisplayedDigitalOrders } from 'researcher/digital-orders/actions';
import { getDigitalTranslations } from 'researcher/digital-orders/reducer';
import withRouter from 'shared/helper/with-router';
import ManageDigitalTranslations from './ManageDigitalTranslations';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var digitalOrders = _ref.digitalOrders,
    user = _ref.user;
  var location = _ref2.location;
  return {
    digitalTranslationsEnabled: digitalOrders.numberOfUsesAvailable > 0,
    digitalTranslations: getDigitalTranslations({
      digitalOrders: digitalOrders
    }),
    pagination: digitalOrders.pagination,
    paginationUrl: getPaginationUrl({
      location: location
    }),
    status: digitalOrders.status,
    uuid: user.identity
  };
};
var mapDispatchToProps = {
  createDigitalOrder: createDigitalOrder,
  getDownloadUrl: getDownloadUrl,
  searchDigitalOrders: searchDigitalOrders,
  updateDisplayedDigitalOrders: updateDisplayedDigitalOrders
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageDigitalTranslations));